<template>
  <div class="flex flex-col gap-3 px-4 pt-2">
    <div class="h-4 bg-grey-100 animate-pulse rounded-md w-3/4" />
    <div class="h-4 bg-grey-100 animate-pulse rounded-md w-full" />
    <div class="h-4 bg-grey-100 animate-pulse rounded-md w-1/2" />
    <div class="h-4 bg-grey-100 animate-pulse rounded-md w-5/6" />
    <div class="h-4 bg-grey-100 animate-pulse rounded-md w-2/3" />
  </div>
</template>
